export class JsonApiWrapper<Type> {
  data: JsonApiData<Type>;

  constructor(attributes: Type, type: string) {
    this.data = new JsonApiData(attributes, type);
  }
}

class JsonApiData<Type> {
  attributes: Type;
  type: string;

  constructor(attributes: Type, type: string) {
    this.attributes = attributes;
    this.type = type;
  }
}
